module.exports = __webpack_public_path__ + "img/1200-120.9b2b2b6e.jpg";